export default __webpack_public_path__ + "static/media/photo--lg--kickoff7.34f438c5.jpg";